import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { get, post } from '../../../../lib/comms';
import SmallLoader from '../../../../components/SmallLoader/SmallLoader';
import Table from 'components/Table/Table';
import { Button } from 'reactstrap';
import ShowMoreText from 'react-show-more-text';
import SubscriptionBanner from 'components/SubscriptionBanner/SubscriptionBanner';
import ToolTip from 'components/ToolTip/TooltTip';

const CONTENT_TYPE_MAP = {
    worship: 'Worship Location',
    notices: 'Notice',
    events: 'Event',
    community: 'Community',
    polls: 'Polls',
};

const columns = [
    { name: 'Id', selector: 'id', grow: 0, sortable: false, hide: 4096 },
    { name: 'Content Title', selector: 'content_title', sortable: true, grow: 1, wrap: true },
    { name: 'Content Type', selector: 'content_type', sortable: false, grow: 1, wrap: true },
    { name: 'Date', selector: 'date', sortable: true, wrap: true, grow: 1 },
    { name: 'Organisation', selector: 'organisation', sortable: true, wrap: true, grow: 1 },
    { name: 'Accuracy', selector: 'accuracy', sortable: true, grow: 1, wrap: true },
    { name: 'Relevance', selector: 'relevance', sortable: true, grow: 1, wrap: true },
    { name: 'Has Comment', selector: 'comment', sortable: true, grow: 1, wrap: true, center: true },
    { name: 'Feedback Count', selector: 'ttl_feedback', sortable: true, grow: 1, wrap: true, center: true },
    { name: '', selector: 'action', sortable: false, grow: 1, wrap: true, width: '200px', center: true },
];

const TabsViewer = ({ tabs, activeTabId, onTabClick }) => {
    return (
        <div>
            <div style={styles.tabsContainer}>
                {tabs.map((tab) => (
                    <div style={styles.tabContainer}>
                        <div
                            className={activeTabId === tab.id ? 'text-tab-active' : 'text-tab'}
                            onClick={() => {
                                onTabClick(tab.id);
                            }}
                        >
                            {tab.value}
                        </div>
                    </div>
                ))}
            </div>
            <div style={styles.tabsBottomContainer} />
        </div>
    );
};

const FeedbackPage = () => {
    const [stepIndex, setStepIndex] = useState(0);
    const [status] = useState('READY'); // LOADING, READY, ERROR
    const [currentTabId, setCurrentTabId] = useState('UNPROCESSED'); // ACTIVE, ARCHIVED
    const [reports, setReports] = useState([]);
    const [singlePostIdFilter, setSinglePostIdFilter] = useState(null);

    const getFeedback = async () => {
        const feedbackTypes = await getFeedbackTypes();

        const response = await get('cms/feedback', {}, true);

        setReports(
            response.feedback.map((item) => {
                const reportReasonIndex = feedbackTypes.filter((type) => item.feedback_type === type)[0];
                const content_type = CONTENT_TYPE_MAP[reportReasonIndex];

                let status;
                let action;
                let accuracy;
                let relevance;

                if (item.accuracy <= 2) {
                    accuracy = (
                        <div style={styles.redContainer}>
                            {item.accuracy > 1 ? (
                                <div style={styles.ttlMultipleReports}>{item.accuracy}</div>
                            ) : (
                                <div style={styles.ttlSingleReports}>{item.accuracy}</div>
                            )}
                        </div>
                    );
                } else if (item.accuracy >= 4) {
                    accuracy = (
                        <div style={styles.greenContainer}>
                            {item.accuracy > 1 ? (
                                <div style={styles.ttlMultipleReports}>{item.accuracy}</div>
                            ) : (
                                <div style={styles.ttlSingleReports}>{item.accuracy}</div>
                            )}
                        </div>
                    );
                } else {
                    accuracy = (
                        <div style={styles.orangeContainer}>
                            {item.accuracy > 1 ? (
                                <div style={styles.ttlMultipleReports}>{item.accuracy}</div>
                            ) : (
                                <div style={styles.ttlSingleReports}>{item.accuracy}</div>
                            )}
                        </div>
                    );
                }

                if (item.relevance <= 2) {
                    relevance = (
                        <div style={styles.redContainer}>
                            {item.relevance > 1 ? (
                                <div style={styles.ttlMultipleReports}>{item.relevance}</div>
                            ) : (
                                <div style={styles.ttlSingleReports}>{item.relevance}</div>
                            )}
                        </div>
                    );
                } else if (item.relevance >= 4) {
                    relevance = (
                        <div style={styles.greenContainer}>
                            {item.relevance > 1 ? (
                                <div style={styles.ttlMultipleReports}>{item.relevance}</div>
                            ) : (
                                <div style={styles.ttlSingleReports}>{item.relevance}</div>
                            )}
                        </div>
                    );
                } else {
                    relevance = (
                        <div style={styles.orangeContainer}>
                            {item.relevance > 1 ? (
                                <div style={styles.ttlMultipleReports}>{item.relevance}</div>
                            ) : (
                                <div style={styles.ttlSingleReports}>{item.relevance}</div>
                            )}
                        </div>
                    );
                }

                const count = response.feedback.filter(
                    (value) => value.post_id === item.post_id && value.processed === 0,
                );
                const countP = response.feedback.filter(
                    (value) => value.post_id === item.post_id && value.processed === 1,
                );

                let ttl_feedbackUnprocessed = (
                    <div className="d-flex">
                        <div onClick={() => setSinglePostIdFilter(item.post_id)} style={styles.ttlReportsContainer}>
                            {count.length > 1 ? (
                                <div style={styles.ttlMultipleReports}>{count.length}</div>
                            ) : (
                                <div style={styles.ttlSingleReports}>{count.length}</div>
                            )}
                        </div>
                        <Button
                            color="link"
                            onClick={() => setSinglePostIdFilter(item.post_id)}
                            style={styles.archivePostButton}
                        >
                            View
                        </Button>
                    </div>
                );

                let ttl_feedback = (
                    <div className="d-flex">
                        <div onClick={() => setSinglePostIdFilter(item.post_id)} style={styles.ttlReportsContainer}>
                            {countP.length > 1 ? (
                                <div style={styles.ttlMultipleReports}>{countP.length}</div>
                            ) : (
                                <div style={styles.ttlSingleReports}>{countP.length}</div>
                            )}
                        </div>
                        <Button
                            color="link"
                            onClick={() => setSinglePostIdFilter(item.post_id)}
                            style={styles.archivePostButton}
                        >
                            View
                        </Button>
                    </div>
                );

                let commentExpanded = (
                    <div>
                        <p>{item.comment}</p>
                    </div>
                );

                let titleExpanded = (
                    <div>
                        <p>{item.content_title}</p>
                    </div>
                );

                if (item.processed === 1) {
                    status = 'PROCESSED';
                    action = <div></div>;
                }

                if (item.processed === 0) {
                    status = 'UNPROCESSED';
                    action = (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                            <Button
                                color="link"
                                onClick={async () => {
                                    await processFeedback(item.id);
                                }}
                                style={styles.archivePostButton}
                            >
                                Mark processed
                            </Button>
                        </div>
                    );
                }

                return {
                    id: item.id,
                    content_type: <b>{content_type}</b>,
                    date: <div style={styles.reportDatetime}>{moment(item.created_at).format('DD/MM/YYYY kk:mm')}</div>,
                    organisation: item.company_name,
                    accuracy: accuracy,
                    relevance: relevance,
                    content_title: (
                        <div>
                            <ShowMoreText lines={3} more="Show more" less="Show less" expanded={false} width={0}>
                                {item.content_title || ''}
                            </ShowMoreText>
                        </div>
                    ),
                    post_id: item.post_id,
                    ttl_feedback,
                    comment: (
                        <div>
                            <p>{item.comment ? 'Yes' : 'No'}</p>
                        </div>
                    ),
                    commentExpanded,
                    titleExpanded,
                    action,
                    status,
                    ttl_feedbackUnprocessed,
                };
            }),
        );
        return response;
    };

    const processFeedback = async (feedbackId) => {
        const response = await post(`cms/feedback/${feedbackId}/process`, {}, true);
        getFeedback();
        return response.status;
    };

    const getFeedbackTypes = async () => {
        const response = await get('/content/feedback_types', {}, true);
        if (response.success) {
            return response.feedbackTypes;
        }
        return [];
    };

    useEffect(() => {
        (async () => {
            getFeedback();
        })();
    }, []);

    return (
        <div className="maincontainer">
            <ToolTip
                callback={(tooltipData) => {
                    if (tooltipData.lifecycle === 'complete') {
                        setStepIndex(tooltipData.action === 'prev' ? tooltipData.index - 1 : tooltipData.index + 1);

                        stepIndex === 0 && tooltipData.action === 'next'
                            ? setStepIndex(stepIndex + 1) && setCurrentTabId('UNPROCESSED')
                            : setCurrentTabId('PROCESSED');

                        stepIndex === 1 && tooltipData.action === 'prev'
                            ? setStepIndex(stepIndex - 1) && setCurrentTabId('PROCESSED')
                            : setCurrentTabId('UNPROCESSED');
                    }
                }}
                screenId={'feedback'}
                steps={[]}
                stepIndex={stepIndex}
            />
            <SubscriptionBanner />
            <h4>Content Feedback</h4>

            {status === 'LOADING' && <SmallLoader color="#0F2B41" />}
            {status === 'READY' && (
                <div>
                    {singlePostIdFilter === null ? (
                        <div style={styles.tabsViewerContainer}>
                            <TabsViewer
                                tabs={[
                                    { value: 'Unprocessed', id: 'UNPROCESSED' },
                                    { value: 'Processed', id: 'PROCESSED' },
                                ]}
                                activeTabId={currentTabId}
                                onTabClick={(currentTabId) => {
                                    setCurrentTabId(currentTabId);
                                    getFeedback(); // to keep it fresh
                                }}
                            />
                        </div>
                    ) : (
                        <div style={styles.tabsViewerContainer}>
                            <Button color="primary" outline onClick={() => setSinglePostIdFilter(null)}>
                                Back
                            </Button>
                        </div>
                    )}
                    <div style={styles.separator} />
                    <Table
                        columns={columns}
                        noDataText={'All up to date'}
                        data={reports
                            .filter((item) => item.status === currentTabId)
                            .filter((item, index) => {
                                if (singlePostIdFilter) {
                                    // if a post has more reports, when we expand the report we see only the related posts
                                    return item.post_id === singlePostIdFilter;
                                } else {
                                    var result = reports.reduce((unique, o) => {
                                        if (
                                            !unique.some(
                                                (obj) => obj.post_id === o.post_id && obj.status === currentTabId,
                                            )
                                        ) {
                                            unique.push(o);
                                        }
                                        return unique;
                                    }, []);
                                    // if all the reports should be shows, even when a post has more reports, only one report per post will be shown
                                    return result.filter((data) => item.id === data.id)[0]; //index === reports.findIndex((i) => i.post_id === item.post_id);
                                }
                            })
                            .map((item) => {
                                if (singlePostIdFilter) {
                                    // if a single post is expanded we want to remove the TTL button (it would be useless)
                                    return {
                                        ...item,
                                        ttl_feedback: null,
                                        comment: item.commentExpanded,
                                        content_title: item.titleExpanded,
                                    };
                                } else {
                                    return {
                                        ...item,
                                        ttl_feedback:
                                            currentTabId === 'UNPROCESSED'
                                                ? item.ttl_feedbackUnprocessed
                                                : item.ttl_feedback,
                                        action: null,
                                        accuracy: null,
                                        relevance: null,
                                    };
                                }
                            })
                            .filter((item) => item.status === currentTabId) // filter between ACTIVE and ARCHIVED
                            .sort((a, b) => a.timestamp - b.timestamp)}
                        tableID="reports"
                        defaultSortField={null}
                    />
                </div>
            )}
            {status === 'ERROR' && <div>Error</div>}
        </div>
    );
};

const styles = {
    archivePostButton: {
        fontWeight: 'normal',
        fontSize: 16,
    },
    reportDatetime: {
        paddingLeft: 20,
    },
    tabsContainer: {
        flexDirection: 'row',
        width: '100%',
        display: 'flex',
    },
    tabContainer: {
        paddignRight: 16,
        paddingLeft: 16,
    },
    tabsBottomContainer: {
        width: '100%',
        backgroundColor: 'rgb(205, 205, 205)',
        height: 1,
        marginTop: 5,
    },
    tabsViewerContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginTop: 20,
    },
    separator: {
        width: '100%',
        height: 1,
        backgroundColor: 'rgb(203, 203, 203)',
    },
    ttlReportsContainer: {
        width: 40,
        height: 40,
        backgroundColor: 'rgb(20, 97, 152)',
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    },
    ttlMultipleReports: {
        fontWeight: 'bold',
        fontSize: 16,
        color: 'white',
    },
    ttlSingleReports: {
        fontWeight: 'bold',
        fontSize: 16,
        color: 'white',
    },
    redContainer: {
        width: 40,
        height: 40,
        backgroundColor: 'red',
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    },
    orangeContainer: {
        width: 40,
        height: 40,
        backgroundColor: 'orange',
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    },
    greenContainer: {
        width: 40,
        height: 40,
        backgroundColor: 'green',
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    },
};

export default FeedbackPage;
